define((require) => {
    "use strict";

    const IntegrationModel = require("editor/ui/settings/integrations/IntegrationModel");

    /**
     * Marker class for Event Collection Uses Matomo.
     *
     * @class EventCollectionUsesMatomoIntegration
     */
    return IntegrationModel.extend("EventCollectionUsesMatomoIntegration", {}, {
        type: "EventCollectionUsesMatomoIntegration"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/EventCollectionUsesMatomoIntegrationModel.js